"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useBanorte = void 0;
const vue_1 = require("vue");
const BanorteService_1 = require("../app/banorte/BanorteService");
function useBanorte() {
    const isLoading = (0, vue_1.ref)(false);
    const isSuccess = (0, vue_1.ref)(false);
    const isError = (0, vue_1.ref)(false);
    const error = (0, vue_1.ref)("");
    const fetch = async (props) => {
        try {
            // let enganche;
            // const MIN_VALUE = 10;
            // const MAX_VALUE = 50;
            // const MIN_FINANCE_AMOUNT = 75000
            // if (props.enganchePercentage < MIN_VALUE) {
            //     enganche = calculatePaymentAmount(props.powerTrain, 20);
            // } else if (props.enganchePercentage > MAX_VALUE){
            //     enganche = calculatePaymentAmount(props.powerTrain, 80);
            // } else {
            //     enganche = props.enganche;
            // }
            isLoading.value = true;
            const response = await (0, BanorteService_1.findOneByCriteria)({
                enganche: props.enganche,
                modelo: props.powerTrain.trim?.model?.year,
                montoSolicitado: props.powerTrain?.price - props.enganche,
                plazo: props.plazo,
                powerTrainId: props.powerTrain.id,
                subsidiaryId: props.subsidiary.id,
                valorFactura: props.powerTrain.price,
                entidadFederativa: props.entidadFederativa,
                tipoSeguro: props.tipoSeguro,
                importeCatSegDanio: props.importeCatSegDanio,
                garantiaExtendida: props.garantia_extendida,
                pagoGarantiaExtendida: props.pago_garantia,
                listaImporteSeguroDano: props.listaImporteSeguroDano
            });
            isSuccess.value = true;
            return response;
        }
        catch (e) {
            isError.value = true;
            error.value = e;
        }
        finally {
            isLoading.value = false;
        }
        return null;
    };
    return { isLoading, isSuccess, isError, error, fetch };
}
exports.useBanorte = useBanorte;
